import i18next from 'i18next';
import React from 'react';

import { formatNumber, formatNumberWithCurrency } from '@commons/DisplayNumber';
import { InpulseLabel } from '@commons/DeepsightComponents';
import { Tooltip } from '@commons/utils/styledLibraryComponents';
import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import { NameText } from '../styledComponents';

const VALUE_PLACEHOLDER = '-';

const SUPPLIER_PRODUCT_DETAILS_PATH = '/admin/suppliers/supplier-products';

export const getColumns = ({ currency }) => [
  {
    id: 'name',
    propertyKey: 'name',
    name: i18next.t('GENERAL.NAME'),
    displayBigger: true,
    render: (name, row) => (
      <Tooltip
        renderTooltipTrigger={() => (
          <NameText
            onClick={(event) => {
              event.stopPropagation();
              window.open(`${SUPPLIER_PRODUCT_DETAILS_PATH}/${row.id}/details`, '_blank');
            }}
          >
            <Text color={ENUM_COLORS.BLACK} font={ENUM_FONTS.TEXT_SMALL_BOLD}>
              {name}
            </Text>
          </NameText>
        )}
        text={name}
        displayBigger
      />
    ),
  },
  {
    id: 'centralKitchenName',
    propertyKey: 'centralKitchenName',
    name: i18next.t('GENERAL.CENTRAL'),
    displayBigger: true,
    filterType: 'string',
  },
  {
    id: 'category',
    propertyKey: 'category',
    name: i18next.t('GENERAL.CATEGORY'),
    filterType: 'string',
    render: (category) => <Text>{category || VALUE_PLACEHOLDER}</Text>,
  },
  {
    id: 'subCategory',
    propertyKey: 'subCategory',
    name: i18next.t('GENERAL.SUB_CATEGORY'),
    filterType: 'string',
    render: (subCategory) => <Text>{subCategory || VALUE_PLACEHOLDER}</Text>,
  },
  {
    id: 'invoicePackagingName',
    propertyKey: 'invoicePackagingName',
    name: i18next.t('ADMIN.SUPPLIER_PRODUCTS.INVOICE_PACKAGING'),
    render: (invoicePackagingName) => <Text>{invoicePackagingName || VALUE_PLACEHOLDER}</Text>,
  },
  {
    id: 'price',
    propertyKey: 'price',
    name: i18next.t('GENERAL.PRICE_EX_TAX'),
    filterType: 'numeric',
    render: (price) => (
      <Text>
        {price != null
          ? formatNumberWithCurrency({ number: price, currency, displayCurrencyCode: true })
          : VALUE_PLACEHOLDER}
      </Text>
    ),
  },
  {
    id: 'vatRate',
    propertyKey: 'vatRate',
    name: i18next.t('GENERAL.VAT_RATE'),
    filterType: 'numeric',
    render: (vatRate) =>
      vatRate != null ? (
        <Text>{`${formatNumber(vatRate, 2)} %`}</Text>
      ) : (
        <Text>{VALUE_PLACEHOLDER}</Text>
      ),
  },
  {
    id: 'shelfLife',
    propertyKey: 'shelfLife',
    name: i18next.t('ADMIN.PRODUCTS.PRODUCT_SHELF_LIFE_BEST_BEFORE'),
    filterType: 'numeric',
    render: (shelfLife) => <Text>{shelfLife != null ? shelfLife : VALUE_PLACEHOLDER}</Text>,
  },
  {
    id: 'active',
    propertyKey: 'active',
    name: i18next.t('GENERAL.STATUS'),
    render: (active) => (
      <InpulseLabel
        color={active ? 'green' : 'red'}
        text={active ? i18next.t('GENERAL.ACTIVE') : i18next.t('GENERAL.INACTIVE')}
      />
    ),
  },
];

export default { getColumns };
